import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import MobileDevPageStage320x100Fs from './freestar/MobileDevPageStage320x100';
import MobileDevPageStage320x100Tab from './taboola/MobileDevPageStage320x100';
const MobileDevPageStage320x100 = ({ safety = 'off', safetyState })=>{
    const isTaboola = useFlag('ads_taboola');
    if (isTaboola) {
        return /*#__PURE__*/ React.createElement(MobileDevPageStage320x100Tab, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(MobileDevPageStage320x100Fs, {
        safety: safety,
        safetyState: safetyState
    });
};
MobileDevPageStage320x100.displayName = 'MobileDevPageStage320x100';
export default MobileDevPageStage320x100;
